var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page3-container" },
    [
      !_vm.isMobile
        ? _c("Step2Desktop", {
            ref: "desktopStep2",
            on: {
              leavebuilder: _vm.leaveBuilder,
              changepage: _vm.changePage,
              gostep: _vm.goStep
            }
          })
        : _c("Step2Mobile", {
            ref: "mobileStep2",
            on: { leavebuilder: _vm.leaveBuilder, changepage: _vm.changePage }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }